import { Controller } from "stimulus"

export default class extends Controller {
  fill(event) {
    const label = event.currentTarget
    label.control.value = label.title
  }
}
